import React, { useState } from 'react'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import colors from "assets/mavric-theme/base/colors.js";
import typography from "assets/mavric-theme/base/typography";
import borders from "assets/mavric-theme/base/borders";
import {
    TextField,
    FormControlLabel,
    Checkbox,
    Container,
    Grid,
    Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, Snackbar, Alert,
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import { searchProbe, deleteProbe } from "apis/CustomersApis";

const { primary, secondary, text, tableRow, transparent, white } = colors;
const { size } = typography;
const { borderRadius } = borders;

const SearchProbe = () => {
    const [probeSerialNum, setProbeSerialNum] = useState(null);
    const [error, setError] = useState(false);
    const [formData, setFormData] = useState({
        serial_number: "",
        name: "",
        model_name: "",
        probe_type: "",
        customer_id: null,
        org_name: "",
        customer_is_active: true,
        customer_act_type: "",
        mavric_product_type: ""
    });
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [pageAlertType, setPageAlertType] = useState("error");
    const [alertState, setAlertState] = useState({ openAlert: false, alertSeverity: "error", alertMessage: "", vertical: 'bottom', horizontal: 'left' });
    const { openAlert, alertSeverity, alertMessage, vertical, horizontal } = alertState;
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [deleteMessageConfirm, setDeleteMessageConfirm] = useState("");
    const [deleteMessageConfirmTitle, setDeleteMessageConfirmTitle] = useState("");
    const [deleteAlertMsg, setDeleteAlertMsg] = useState("");

    const handleChange = (event) => {
        const newValue = event.target.value;
        if (newValue !== '' || /^\d+$/.test(newValue) || newValue.length > 0 && newValue.isEmptyObject()) {
            setProbeSerialNum(newValue);
            setError(false);
        } else {
            setProbeSerialNum(null);
            setError(true);
        }
    };

    const handleSearch = async () => {
        try {
            if (!probeSerialNum) {
                setError(true);
                return;
            } else {
                let result = await searchProbe(probeSerialNum);
                console.log("Handle serach in Probe page::", result);
                if (result.code === 200) {
                    setFormData(result.payload);
                } else {
                    setProbeSerialNum("");
                    // setShowDeleteAlert(true);
                    // setPageAlertType("error");
                    // setDeleteAlertMsg(`Error: ${result.message}`);
                }
            }
        } catch (error) {
            console.error("Search error:", error);
            setProbeSerialNum("");
            setShowDeleteAlert(true);
            setPageAlertType("error");
            // setDeleteAlertMsg(`Error: ${probeSerialNum} Probe Info does not exist`);
            setDeleteAlertMsg(`Probe Info Not Found`);
            resetForm();
        }
    }

    const handleCancel = () => {
        resetForm();
        setProbeSerialNum("");
    };

    const handleDeleteSearchProbe = () => {
        let strMsg = "Are you sure you want to delete?";
        setDeleteMessageConfirm(strMsg);
        setDeleteMessageConfirmTitle("Delete selected");
        setConfirmDeleteOpen(true);
    };

    const handleDeleteYes = () => {
        setConfirmDeleteOpen(false);
        // handleConfirmClose();
        console.log("formData::", formData);
        if (formData.serial_number) {
            deleteProbes(formData);
        }
        // resetMyFilters();
        // setSelectedProbes([]);
    }

    const handleDeleteNo = () => {
        setConfirmDeleteOpen(false);
        handleConfirmClose();
    };

    const handleConfirmClose = () => {
        setConfirmDeleteOpen(false);
    };

    const deleteProbes = async (selectedProbes) => {
        let errorList = [];
        let deletedUsers = [];

        try {
            const result = await deleteProbe(selectedProbes.serial_number);
            console.log(result);
            if (result.code !== 200) {
                probeInfo['error_msg'] = JSON.stringify(result);
                errorList.push(selectedProbes);
            } else {
                deletedUsers.push(selectedProbes);
                resetForm();
            }
        } catch (error) {
            probeInfo['error_msg'] = error;
            errorList.push(selectedProbes);
        }

        setShowDeleteAlert(true);
        if (errorList.length > 0) {
            console.error("Error: Probe List :", errorList);
            setPageAlertType("error");
            setDeleteAlertMsg(`Error: ${errorList.length} probe was not deleted`);
        } else {
            setPageAlertType("success");
            setDeleteAlertMsg(`Success : ${deletedUsers.length} probe was deleted`);
        }
    };

    const handleDeleteAlertClose = (event, reason) => {

        if (reason === 'clickaway') {
            return;
        }
        setAlertState({ ...alertState, openAlert: false });
        setShowDeleteAlert(false);

    }

    const resetForm = () => {
        setFormData({
            serial_number: "",
            name: "",
            model_name: "",
            probe_type: "",
            customer_id: null,
            org_name: "",
            customer_is_active: true,
            customer_act_type: "",
            mavric_product_type: "",
        });
    };

    const data = pageAlertType || deleteAlertMsg

    return (
        <div>
            <Box sx={{ width: "100%", marginLeft: 2, marginBottom: 2, display: "flex", alignItems: "center", gap: 2 }}>
                <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 600, marginBottom: '8px', whiteSpace: "nowrap" }}>
                    Search Probe :
                </Typography>
                <TextField
                    required
                    id={`txtFldProbeInfo`}
                    name="probeInfo"
                    type="search"
                    text="number"
                    value={probeSerialNum}
                    onChange={handleChange}

                    autoComplete="off"
                    InputProps={{ readOnly: false, sx: { color: text.main } }}
                    sx={{ width: 250, color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
                    placeholder="Enter Probe Number"
                    InputLabelProps={{ sx: { color: text.main }, }}
                    error={error}
                    helperText={error ? "Please enter digits only" : ""}
                />
                <Button variant="contained" sx={{ mr: 0 }} color="secondary" aria-label="Search" onClick={handleSearch}>Search</Button>
                <Button variant="contained" color="secondary" disabled={!probeSerialNum} onClick={handleCancel}>Clear</Button>

                {showDeleteAlert && deleteAlertMsg && (
                    <Box sx={{ marginBottom: 0 }}>
                        <Snackbar
                            open={showDeleteAlert}
                            autoHideDuration={4000} 
                            onClose={handleDeleteAlertClose}
                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}  
                            sx={{ 
                                position: 'relative',  
                                marginBottom: 6, 
                            }}
                        >
                            <Alert
                                elevation={6}
                                variant="filled"
                                onClose={handleDeleteAlertClose}
                                severity={pageAlertType || "error"}
                                sx={{
                                    "& .MuiAlert-message": {
                                        color: white.main,
                                        fontSize: size.sm
                                    }
                                }}
                            >
                                {deleteAlertMsg}
                            </Alert>
                        </Snackbar>
                    </Box>
                )}

            </Box>
            {formData.serial_number !== "" ? (
                <>
                    <Container maxWidth="sm" style={{ marginTop: '2rem' }}>
                        {/* <Typography variant="h5" gutterBottom>
                            Product Details (Read-Only)
                        </Typography> */}
                        <Grid container spacing={2}>
                            {[
                                { label: 'Serial Number', name: 'serial_number' },
                                { label: 'Name', name: 'name' },
                                { label: 'Model Name', name: 'model_name' },
                                { label: 'Probe Type', name: 'probe_type' },
                                { label: 'Customer ID', name: 'customer_id' },
                                { label: 'Organization Name', name: 'org_name' },
                                { label: 'Customer Act Type', name: 'customer_act_type' },
                                { label: 'Mavric Product Type', name: 'mavric_product_type' },
                            ].map((field) => (
                                <Grid item xs={12} sm={4} md={4} lg={4} key={field.name}>
                                    <TextField
                                        fullWidth
                                        label={field.label}
                                        name={field.name}
                                        value={formData[field.name] ?? ''}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                    />
                                </Grid>
                            ))}
                            <Grid item xs={12} sm={4} md={4} lg={4}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={formData.customer_is_active}
                                            name="customer_is_active"
                                            disabled
                                        />
                                    }
                                    label="Customer is Active"
                                />
                            </Grid>
                            <Grid item xs={6}>

                                <Button variant="contained" color="secondary" onClick={handleDeleteSearchProbe}>
                                    Delete
                                </Button>
                            </Grid>
                        </Grid>
                    </Container>
                </>
            ) : (<></>)}

            <Dialog open={confirmDeleteOpen} onClose={handleConfirmClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" maxWidth='md'
                sx={{
                    '& .MuiDialog-paper': {
                        backgroundColor: primary.main,
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title">
                    <Typography fontSize={size.lg} color={secondary.main} sx={{ fontWeight: 600, }}>{deleteMessageConfirmTitle}</Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">{deleteMessageConfirm}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" startIcon={<CancelIcon />}
                        onClick={handleDeleteNo}>No</Button>

                    <Button variant="contained" color="secondary" startIcon={<DeleteIcon />}
                        onClick={handleDeleteYes} autoFocus>Yes</Button>
                </DialogActions>
            </Dialog>
            {/* <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={showDeleteAlert}
                autoHideDuration={6000}
                key={vertical + horizontal}
                onClose={handleDeleteAlertClose}
            >
                <Alert elevation={6} variant="filled" onClose={handleDeleteAlertClose}
                    severity={pageAlertType || "error"} sx={{ "& .MuiAlert-message" :{ color: white.main, fontSize: size.sm}, marginBottom: 4 }}
                    >
                {deleteAlertMsg}
                </Alert>
            </Snackbar> */}
        </div>
    )
}

export default SearchProbe
